import React, { useState } from 'react';
import Button from '@mui/material/Button';
import BootstrapButton from 'react-bootstrap/Button';
import Backdrop from '@mui/material/Backdrop';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';


function TemplateDeleteButton(props) {

    const { deleteTemplate, templateId, backdropOpen, setBackdropOpen } = props;

    const [open, setOpen] = useState(false);
  
    // Handlers for opening and closing the backdrop
    const handleOpen = () => {
      setBackdropOpen(true);
    };
  
    const handleClose = () => {
      setBackdropOpen(false);
    };
  
    // The actual delete action
    const handleDelete = () => {
        deleteTemplate(templateId);
        handleClose();
    };

    React.useEffect(() => {
      setOpen(backdropOpen);
    }, [backdropOpen])
  
    return (
      <>
        <BootstrapButton className="Font_Micro" style={{maxHeight: 30}} variant="danger" size="sm" onClick={handleOpen}><FontAwesomeIcon className="Icon_Size" icon={faTrashCan} /> Delete</BootstrapButton>
        <Backdrop
          open={open}
          onClick={handleClose}
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}
        >
          <Box sx={{ bgcolor: 'background.paper', borderRadius: 2, p: 2, zIndex: 2000 }}>
            <Alert severity="warning">
              <AlertTitle>Are you sure you want to delete this template?</AlertTitle>
              This action cannot be undone.
              <Box mt={2}>
                <Button variant="outlined" color="warning" onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="warning"
                  onClick={handleDelete}
                  sx={{ marginLeft: 1 }}
                >
                  Confirm
                </Button>
              </Box>
            </Alert>
          </Box>
        </Backdrop>
      </>
    );
  }
  
  export default TemplateDeleteButton;
  